"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formatDistance_1 = __importDefault(require("date-fns/formatDistance"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const MomentsAgo = (props) => {
    const { value, excludeSuffix } = props;
    let label = formatDistance_1.default(new Date(value), new Date(), { addSuffix: true });
    if (excludeSuffix) {
        label = label.replace('about', '').replace('ago', '').replace('in ', '');
    }
    return (react_1.default.createElement("span", Object.assign({}, helpers_1.usePrimitiveProps(props)), label.trim()));
};
exports.default = withJourney_1.default('j-moments-ago', MomentsAgo);
